import { IconButton } from "@mui/material";
import PhotoSizeSelectLargeIcon from "@mui/icons-material/PhotoSizeSelectLarge";
import PhotoSizeSelectSmallIcon from "@mui/icons-material/PhotoSizeSelectSmall";
import { useAtom } from "jotai";
import { productRowSizeAtom } from "../../features/products/product-view.state";

/** Toggles thumbnail/row size across every product list. Persisted in localStorage. */
export const RowSizeToggle = () => {
  const [rowSize, setRowSize] = useAtom(productRowSizeAtom);
  const isLarge = rowSize === "large";
  const label = isLarge ? "Smaller images" : "Bigger images";

  return (
    <IconButton
      size="small"
      title={label}
      aria-label={label}
      onClick={() => setRowSize(isLarge ? "compact" : "large")}
    >
      {isLarge ? <PhotoSizeSelectSmallIcon /> : <PhotoSizeSelectLargeIcon />}
    </IconButton>
  );
};
